<template>
  <card
    title="איחורים באיסוף"
    :linkTo="`/orders?orderStatuses=${paidStatusId}&startDateBefore=${format(subDays(Date(), 0), 'YYYY-MM-DD')}`"
    actionButton="לכל האיחורים באיסוף"
    :number="number"
    :loading="loading"
    :error="error"
  />
</template>

<script>
import { format, subDays } from 'date-fns';
import { getApi } from '@/api';
import Card from "./Card.vue";

export default {
  data() {
    return {
      number: 0,
      loading: false,
      error: false
    };
  },

  computed: {
    paidStatusId() {
      let paidStatus = Object.values(this.$store.state.entities.orderStatuses).find(item => {
        return item.key === 'PAID';
      })
      return paidStatus ? paidStatus._id : null;
    }
  },

  methods: {
    format,
    subDays,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            startDateBefore: format(subDays(Date(), 1), 'YYYY-MM-DD'),
            orderStatuses: this.paidStatusId
          };
          return api.get('/orders', { params })
        })
        .then(({ data }) => {
          this.number = data.totalResults;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },

  props: [],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
